<template>
  <div class="bt-noti-wrap noti-two-col">
    <div v-if="$route.name === 'oksusu'" class="bt-noti">
      <p class="bt-noti-tit">프로모션 주의 사항</p>
      <p class="dot-text">
        3개월 간 4,000원 프로모션은 해당 이용권 유지 시에만 적용됩니다.
      </p>
      <p class="dot-text">
        할인 적용 여부는 최종 구매 페이지에서 확인 가능합니다.
      </p>
      <p class="dot-text">
        다른 이용권으로 변경 시 프르모션 혜택이 종료됩니다.
      </p>
      <p class="dot-text">
        이 프로모션은 현재 페이지에서 구매 시에만 적용 가능합니다.
      </p>
      <p class="dot-text">
        POOQ 이용권 페이지 내 동일한 금액의 동일한 이용권이더라도 프로모션
        상품이 아니므로 이용권 변경 시 프로모션 혜택은 종료됩니다.
      </p>
    </div>
    <div class="bt-noti">
      <p class="bt-noti-tit">서비스 이용 주의사항</p>
      <p class="dot-text">
        <span
          >Wavve 서비스는 국내 및 해외 서비스 대상 국가에서 이용하실 수
          있습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >이용권 및 개별 구매 영화는 국내에서 결제 가능하고, 결제 후 해외
          서비스 대상국가에서 모바일/태블릿 앱으로 (ios/Android) 7일간 시청할 수
          있습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >일부 콘텐츠는 콘텐츠 제공사의 요청으로 해외 서비스 대상 국가에서도
          이용이 불가합니다.</span
        >
      </p>
      <p class="dot-text">
        <span>해외 서비스 대상 국가에서는 다운로드를 제공하지 않습니다.</span>
      </p>
      <p class="dot-text">
        <span
          >해외 서비스 대상 국가 : 싱가폴, 인도네시아, 말레이시아, 필리핀,
          베트남, 라오스, 태국</span
        >
      </p>
      <p class="dot-text">
        <span
          >해외 서비스 대상 국가가 아닌 국가에서는 서비스 이용이
          불가합니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >프리미엄 이용권은 동시에 4명, 스텐다드 이용권은 2명이 동시에 시청할
          수 있습니다. 베이직 이용권은 1명만 시청할 수 있습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >일부 콘텐츠는 콘텐츠 제공사의 요청으로 LIVE 및 VOD 서비스를 제공하지
          않을 수 있습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >일부 콘텐츠는 콘텐츠 제공사의 요청으로 FHD 화질을 제공하지 않을 수
          있습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >콘텐츠에 따라 다운로드를 제공하지 않을 수 있으며, 이용권에 따라
          다운로드 횟수가 제한됩니다.</span
        >
      </p>
      <p class="dot-text"><span>TV 기기에서는 다운로드가 불가합니다.</span></p>
      <p class="dot-text">
        <span
          >프리미엄 이용권은 일부 콘텐츠를 최고화질(4K UHD, Dolby, HDR)로 시청할
          수 있습니다. 최고화질은 이용하는 기기의 사양, 네트워크 환경 등에 따라
          변경될 수 있습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >이용 기기 중 TV 는 Wavve앱이 설치가 되어 있거나 앱스토어에서 설치가
          가능한 스마트TV 및 Android TV 기기이며, TV에서는 일부 채널은 LIVE
          서비스를 제공하지 않습니다.
          <a
            href="/customer/faq.html?searchWord=%EC%8B%A4%EC%8B%9C%EA%B0%84%20%EC%B1%84%EB%84%90"
            class="noti-more"
            >자세히보기</a
          >
        </span>
      </p>
      <p class="dot-text">
        <span
          >LG 스마트 TV 이외의 TV에서는 콘텐츠제공사의 요청으로 LIVE 서비스를
          제공하지 않습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >구형 smart TV에서 DRM콘텐츠 재생이 종료됨에 따라 서비스가 제공되지
          않을 수 있습니다.
          <a
            href="/customer/notice_view?filterType=all&noticeId=2900"
            class="noti-more"
            >자세히보기</a
          ></span
        >
      </p>
      <p class="dot-text">
        <span
          >자사의 콘텐츠 보호 정책에 따라 높은 등급의 보안 인증을 (Microsoft
          Playready SL3000 이상 / Google Widevine L1 이상 / Apple FairPlay) 받지
          않은 기기이거나 HDCP 2.2 이상이 아닌 기기로 UHD(4K) 재생 시 낮은
          화질(FHD 이하)로 재생될 수 있습니다.</span
        >
      </p>
    </div>
    <!--bt-noti//-->

    <div class="bt-noti">
      <p class="bt-noti-tit">서비스 이용 권장사양</p>
      <p class="dot-text">
        <span
          >PC : Windows 10 이상, MacOS 10.12 이상. Chrome/Edge/Safari 등 HTML 5
          지원 브라우저 최신 버전,<br />스마트폰 : Android 11 버전 이상, iOS 15
          버전 이상의 국내 출시 모델,<br />태블릿 : Android 11 버전 이상, iOS 15
          버전 이상의 국내 출시 모델,<br />TV : 삼성 스마트TV Tizen 3.0 이상의
          모델 / LG 스마트TV webOS 3.5 이상의 모델</span
        >
      </p>
    </div>
    <!--bt-noti//-->

    <div class="bt-noti">
      <p class="bt-noti-tit">이용권 구매 주의사항</p>
      <p class="dot-text">
        <span>모든 이용권은 부가세(VAT) 포함 가격입니다.</span>
      </p>
      <p class="dot-text"><span>이용권 가격은 변경될 수 있습니다.</span></p>
      <p class="dot-text">
        <span
          >Google Play 결제 금액은 PC/모바일웹 결제 금액과 상이합니다.
          <a
            href="/customer/notice_view?filterType=service&noticeId=2865&pageNum=1&searchWord="
            class="noti-more"
            >자세히보기</a
          >
        </span>
      </p>
      <p class="dot-text">
        <span
          >자동결제는 1개월 주기로 매월 구매한 날과 동일한 날짜에 결제됩니다.
          해당월에 동일한 날짜가 없으면 말일에 결제됩니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >연간 이용권(12개월)의 경우 년1회 결제 구매한 날과 동일한 날짜에
          결제되며, 해당 일자가 없는 경우 해당 월의 말일에 결제됩니다.
        </span>
      </p>
      <p class="dot-text">
        <span
          >결제 당일을 제외한 이용기간 중 언제든지 자동결제를 해지하실 수
          있습니다. 해지하면 더 이상 추가 결제되지 않으며, 다음 결제 예정일까지
          서비스를 계속 이용할 수 있습니다.
          <a href="#" class="noti-more" @click.prevent="moveUrl()"
            >구매내역 바로가기</a
          >
        </span>
      </p>
      <p class="dot-text">
        <span
          >제휴 이용권은 할인한 가격이므로 추가 혜택(페이백, 기타 할인 등)을
          제공하지 않습니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >자동 결제 연동이 필요한 프로모션 쿠폰 사용 중에는 다른 할인 이벤트가
          노출되지 않을 수 있으며, 구독 또한 불가합니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >통신사, 신용카드 정보 변경 및 잔액부족 시에는 결제실패로 자동결제가
          해지될 수 있습니다.</span
        >
      </p>
      <p class="dot-text">
        <span>고객센터를 통한 자동결제해지 신청은 본인만 가능합니다.</span>
      </p>
      <p class="dot-text">
        <span>
          이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가 가능합니다.
          자세한 사항은
          <a
            href="https://www.wavve.com/customer/agreement?category=payment"
            class="noti-more"
            target="_blank"
            rel="noopener noreferrer"
            >'유료상품 이용약관'</a
          >
          제10조를 참조하시기 바랍니다.
        </span>
      </p>
      <p class="dot-text">
        <span
          >12개월 이용권의 경우, 장기 이용에 대한 할인 혜택이 적용된 금액이므로
          중도 해지 시에는 1개월 이용권 기준의 할인 미적용 정상가 기준으로 일할
          계산하여 환불 금액이 정산되오니 유의 부탁드립니다.</span
        >
      </p>
      <p class="dot-text">
        <span>12개월 이용권 추가 할인 프로모션은 필요 시 진행됩니다.</span>
      </p>
      <p class="dot-text">
        <span
          >12개월 이용권 추가할인 프로모션 기간에 할인 상품 구매 시 첫 해에만
          추가 할인 금액으로 결제되고, 12개월 후에는 기존 금액 (16% 할인)으로 연
          1회 정기 결제됩니다.</span
        >
      </p>
      <p class="dot-text">
        <span
          >이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분 환불이
          진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한 경우 할인
          미적용 기준으로 환불 금액이 정산 됩니다.)</span
        >
      </p>
      <p class="dot-text">
        <span
          >이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브
          <a href="https://member.wavve.com/customer/qna/ask" class="noti-more"
            >고객센터</a
          >에 연락해 주시기 바랍니다.</span
        >
      </p>
    </div>
    <!--bt-noti//-->
  </div>
  <!--ticket-bt-noti//-->
</template>

<script>
  import cookie from '@/common/utils/cookie'
  import {
    PATH_NAME_LOGIN,
    PATH_NAME_SUBSCRIPTION_TICKET,
  } from '@/common/resources/router.const'
  export default {
    methods: {
      moveUrl() {
        if (cookie.isCsInfo()) {
          this.$router.push({ name: PATH_NAME_SUBSCRIPTION_TICKET })
        } else {
          this.$router.push({ name: PATH_NAME_LOGIN })
        }
      },
    },
  }
</script>
